// Load assets from Cloudinary
const CACHE: { [key: string]: Promise<HTMLElement> } = {};

export type FetchFn = (url: string) => Promise<string>;

// @todo these are cached for very long durations by cloudflare - we need to update so they redeploy on change
const release = Date.now();

export async function loadSvg(key: string, doc: Document, fetch: FetchFn) {
  if (CACHE[key] === undefined) {
    console.log(`Loading ${key}`);
    CACHE[key] = fetch(`${key}?ts=${release}`)
      .then((resp) => {
        const el = doc.createElement("div");
        el.innerHTML = resp;

        return el.firstChild as HTMLElement;
      })
      .catch((err) => {
        // Error loading resource
        console.error("Error loading resource", err);
        return doc.createElement("svg");
      });
  }

  return CACHE[key];
}
